// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AgenteRaciocinioRouteImport } from './routes/agente-raciocinio'
import { Route as AprovafeoOrtoRouteImport } from './routes/aprovafeo-orto'
import { Route as AprovafeoOrtoBkpRouteImport } from './routes/aprovafeo-orto-bkp'
import { Route as AprovafeoOrtoPadraoBkpRouteImport } from './routes/aprovafeo-orto-padrao-bkp'
import { Route as AulasExperimentaisDorRouteImport } from './routes/aulas-experimentais-dor'
import { Route as AulasExperimentaisEsporteRouteImport } from './routes/aulas-experimentais-esporte'
import { Route as AulasExperimentaisGerontologiaRouteImport } from './routes/aulas-experimentais-gerontologia'
import { Route as AulasExperimentaisOrtoRouteImport } from './routes/aulas-experimentais-orto'
import { Route as AulasExperimentaisPosTodasRouteImport } from './routes/aulas-experimentais-pos-todas'
import { Route as AulasExperimentaisTraumaRouteImport } from './routes/aulas-experimentais-trauma'
import { Route as BlackFaqRouteImport } from './routes/black-faq'
import { Route as BlackListaRouteImport } from './routes/black-lista'
import { Route as BlackListaEntregasRouteImport } from './routes/black-lista-entregas'
import { Route as BlackOfertaRouteImport } from './routes/black-oferta'
import { Route as BlackOfertaAlunosRouteImport } from './routes/black-oferta-alunos'
import { Route as BlackOfertaCbfeoRouteImport } from './routes/black-oferta-cbfeo'
import { Route as BlackOfertaEntregasRouteImport } from './routes/black-oferta-entregas'
import { Route as BlackQuizzRouteImport } from './routes/black-quizz'
import { Route as BlackfeoRouteImport } from './routes/blackfeo'
import { Route as BlackfeoEntregasRouteImport } from './routes/blackfeo-entregas'
import { Route as BolsasFeoProvaRouteImport } from './routes/bolsas-feo-prova'
import { Route as BolsasFeoResultadosRouteImport } from './routes/bolsas-feo-resultados'
import { Route as CbfeoRouteImport } from './routes/cbfeo'
import { Route as CbfeoAoVivoRouteImport } from './routes/cbfeo-ao-vivo'
import { Route as CertificacaoRouteImport } from './routes/certificacao'
import { Route as CertificacaoBkpRouteImport } from './routes/certificacao-bkp'
import { Route as CertificacaoCervicalRouteImport } from './routes/certificacao-cervical'
import { Route as CertificacaoEletroRouteImport } from './routes/certificacao-eletro'
import { Route as CertificacaoJoelhoRouteImport } from './routes/certificacao-joelho'
import { Route as CertificacaoLombarRouteImport } from './routes/certificacao-lombar'
import { Route as CertificacaoOmbroRouteImport } from './routes/certificacao-ombro'
import { Route as CertificacaoQuadrilRouteImport } from './routes/certificacao-quadril'
import { Route as CertificacaoQuadrilBkpRouteImport } from './routes/certificacao-quadril-bkp'
import { Route as CertificacaoQuadrilGrupoRouteImport } from './routes/certificacao-quadril-grupo'
import { Route as CertificacaoQuadrilOfertaRouteImport } from './routes/certificacao-quadril-oferta'
import { Route as CertificacaoQuadrilV2RouteImport } from './routes/certificacao-quadril-v2'
import { Route as CertificacaoQuadril2RouteImport } from './routes/certificacao-quadril2'
import { Route as CertificacaoStarRouteImport } from './routes/certificacao-star'
import { Route as CertificacaoTornozeloRouteImport } from './routes/certificacao-tornozelo'
import { Route as ComboImersoesRouteImport } from './routes/combo-imersoes'
import { Route as DepoimentosRouteImport } from './routes/depoimentos'
import { Route as Dor1RouteImport } from './routes/dor1'
import { Route as Dor2RouteImport } from './routes/dor2'
import { Route as EFisioRouteImport } from './routes/e-fisio'
import { Route as EmentaDorRouteImport } from './routes/ementa-dor'
import { Route as EmentaEsporteRouteImport } from './routes/ementa-esporte'
import { Route as EmentaGerontoRouteImport } from './routes/ementa-geronto'
import { Route as EmentaOrtoRouteImport } from './routes/ementa-orto'
import { Route as EmentaPrescricaoRouteImport } from './routes/ementa-prescricao'
import { Route as EmentaTraumaRouteImport } from './routes/ementa-trauma'
import { Route as EmentasRouteImport } from './routes/ementas'
import { Route as Esporte1RouteImport } from './routes/esporte1'
import { Route as Esporte2RouteImport } from './routes/esporte2'
import { Route as FeoclinicasRouteImport } from './routes/feoclinicas'
import { Route as Feoclinicas2RouteImport } from './routes/feoclinicas-2'
import { Route as FisiocompletoRouteImport } from './routes/fisiocompleto'
import { Route as FisiocompletoVendaRouteImport } from './routes/fisiocompleto-venda'
import { Route as FisiocompletoWppRouteImport } from './routes/fisiocompleto-wpp'
import { Route as FlashfeoRouteImport } from './routes/flashfeo'
import { Route as FunilLcaRouteImport } from './routes/funil-lca'
import { Route as FunilLcaComboImersoesRouteImport } from './routes/funil-lca-combo-imersoes'
import { Route as FunilSdfpRouteImport } from './routes/funil-sdfp'
import { Route as FunilSdfpComboImersoesRouteImport } from './routes/funil-sdfp-combo-imersoes'
import { Route as FunilTmanualRouteImport } from './routes/funil-tmanual'
import { Route as FunilTmanualComboImersoesRouteImport } from './routes/funil-tmanual-combo-imersoes'
import { Route as FunilUsRouteImport } from './routes/funil-us'
import { Route as FunilUsComboImersoesRouteImport } from './routes/funil-us-combo-imersoes'
import { Route as Geronto1RouteImport } from './routes/geronto1'
import { Route as Geronto2RouteImport } from './routes/geronto2'
import { Route as ImersaoPbeRouteImport } from './routes/imersao-pbe'
import { Route as ImersaoPbeStarRouteImport } from './routes/imersao-pbe-star'
import { Route as InteligenciaBlack25RouteImport } from './routes/inteligencia-black25'
import { Route as InteligenciaGolpeRouteImport } from './routes/inteligencia-golpe'
import { Route as Orto1RouteImport } from './routes/orto1'
import { Route as Orto2RouteImport } from './routes/orto2'
import { Route as PassaporteRouteImport } from './routes/passaporte'
import { Route as PlantaofeoRouteImport } from './routes/plantaofeo'
import { Route as PoliticaDePrivacidadeRouteImport } from './routes/politica-de-privacidade'
import { Route as PosRouteImport } from './routes/pos'
import { Route as PosBkpRouteImport } from './routes/pos-bkp'
import { Route as PosGgRouteImport } from './routes/pos-gg'
import { Route as Prescricao1RouteImport } from './routes/prescricao1'
import { Route as Prescricao2RouteImport } from './routes/prescricao2'
import { Route as ProfessoresRouteImport } from './routes/professores'
import { Route as QuemSomosRouteImport } from './routes/quem-somos'
import { Route as QuizzDorPosTodasRouteImport } from './routes/quizz-dor-pos-todas'
import { Route as QuizzPosTodasRouteImport } from './routes/quizz-pos-todas'
import { Route as RevistaRouteImport } from './routes/revista'
import { Route as RevistaStarRouteImport } from './routes/revista-star'
import { Route as RoteiroAvaliacao1RouteImport } from './routes/roteiro-avaliacao-1'
import { Route as RoteiroAvaliacao2RouteImport } from './routes/roteiro-avaliacao-2'
import { Route as SemanadafisioRouteImport } from './routes/semanadafisio'
import { Route as SemanadafisioAulasRouteImport } from './routes/semanadafisio-aulas'
import { Route as SemanadafisioggRouteImport } from './routes/semanadafisiogg'
import { Route as StarRouteImport } from './routes/star'
import { Route as Star2RouteImport } from './routes/star2'
import { Route as Trauma1RouteImport } from './routes/trauma1'
import { Route as Trauma2RouteImport } from './routes/trauma2'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAcessosRouteImport } from './routes/admin.acessos'
import { Route as AdminAcoesMarketingRouteImport } from './routes/admin.acoes-marketing'
import { Route as AdminAdminRouteImport } from './routes/admin.admin'
import { Route as AdminBannerRouteImport } from './routes/admin.banner'
import { Route as AdminBibliotecaAnunciosRouteImport } from './routes/admin.biblioteca-anuncios'
import { Route as AdminBlackDashboardRouteImport } from './routes/admin.black-dashboard'
import { Route as AdminBlackLeadsRouteImport } from './routes/admin.black-leads'
import { Route as AdminBlackNovemberRouteImport } from './routes/admin.black-november'
import { Route as AdminBlackNovemberDashboardRouteImport } from './routes/admin.black-november-dashboard'
import { Route as AdminBlackNovemberPaginasRouteImport } from './routes/admin.black-november-paginas'
import { Route as AdminBlack25CrmDiretaRouteImport } from './routes/admin.black25-crm-direta'
import { Route as AdminBolsasFeoRouteImport } from './routes/admin.bolsas-feo'
import { Route as AdminCampanhasRouteImport } from './routes/admin.campanhas'
import { Route as AdminCampanhasModeloRouteImport } from './routes/admin.campanhas-modelo'
import { Route as AdminConfiguracoesRouteImport } from './routes/admin.configuracoes'
import { Route as AdminContextoRouteImport } from './routes/admin.contexto'
import { Route as AdminCopysRouteImport } from './routes/admin.copys'
import { Route as AdminDashboardRouteImport } from './routes/admin.dashboard'
import { Route as AdminDashboard2RouteImport } from './routes/admin.dashboard-2'
import { Route as AdminDepoimentosRouteImport } from './routes/admin.depoimentos'
import { Route as AdminDiagnosticoComercialRouteImport } from './routes/admin.diagnostico-comercial'
import { Route as AdminEFisioRouteImport } from './routes/admin.e-fisio'
import { Route as AdminFeoGuardRouteImport } from './routes/admin.feo-guard'
import { Route as AdminFeoclinicasRouteImport } from './routes/admin.feoclinicas'
import { Route as AdminHistoricoRouteImport } from './routes/admin.historico'
import { Route as AdminHistoricoOperacaoRouteImport } from './routes/admin.historico-operacao'
import { Route as AdminInteligenciaLeadsRouteImport } from './routes/admin.inteligencia-leads'
import { Route as AdminInteligenciaMarketingRouteImport } from './routes/admin.inteligencia-marketing'
import { Route as AdminLeadsRouteImport } from './routes/admin.leads'
import { Route as AdminMapaRouteImport } from './routes/admin.mapa'
import { Route as AdminPainelRouteImport } from './routes/admin.painel'
import { Route as AdminPlacarRouteImport } from './routes/admin.placar'
import { Route as AdminPlanoB2bRouteImport } from './routes/admin.plano-b2b'
import { Route as AdminPlanoBlack2x1RouteImport } from './routes/admin.plano-black-2x1'
import { Route as AdminPlanoBlackNovemberRouteImport } from './routes/admin.plano-black-november'
import { Route as AdminPlanoBolsasFeoRouteImport } from './routes/admin.plano-bolsas-feo'
import { Route as AdminPlanoEFisioRouteImport } from './routes/admin.plano-e-fisio'
import { Route as AdminPlanoInteligenciaLeadsRouteImport } from './routes/admin.plano-inteligencia-leads'
import { Route as AdminPlanoLeadsRdCrmRouteImport } from './routes/admin.plano-leads-rd-crm'
import { Route as AdminPlanoMigracaoRouteImport } from './routes/admin.plano-migracao'
import { Route as AdminPlanoPaginasRouteImport } from './routes/admin.plano-paginas'
import { Route as AdminPlanoRevisaoPreBlackRouteImport } from './routes/admin.plano-revisao-pre-black'
import { Route as AdminPlanoRoteadorGruposRouteImport } from './routes/admin.plano-roteador-grupos'
import { Route as AdminPlanoTrackingGtmRouteImport } from './routes/admin.plano-tracking-gtm'
import { Route as AdminPlanosRouteImport } from './routes/admin.planos'
import { Route as AdminPublicosRouteImport } from './routes/admin.publicos'
import { Route as AdminQuizzRouteImport } from './routes/admin.quizz'
import { Route as AdminReportsRouteImport } from './routes/admin.reports'
import { Route as EFisioIndexRouteImport } from './routes/e-fisio.index'
import { Route as EFisioSlugRouteImport } from './routes/e-fisio.$slug'
import { Route as AdminEFisioConfiguracoesRouteImport } from './routes/admin.e-fisio_.configuracoes'
import { Route as EFisioCategoriaSlugRouteImport } from './routes/e-fisio.categoria.$slug'
import { Route as EmbedBannerSlideKeyRouteImport } from './routes/embed.banner-slide.$key'
import { Route as EmbedEmentaSlugRouteImport } from './routes/embed.ementa.$slug'
import { Route as EmbedPreCheckoutGgSlugRouteImport } from './routes/embed.pre-checkout-gg.$slug'
import { Route as EmbedPreCheckoutSlugRouteImport } from './routes/embed.pre-checkout.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AgenteRaciocinioRoute = AgenteRaciocinioRouteImport.update({
            id: '/agente-raciocinio',path: '/agente-raciocinio',getParentRoute: () => rootRouteImport
          })
const AprovafeoOrtoRoute = AprovafeoOrtoRouteImport.update({
            id: '/aprovafeo-orto',path: '/aprovafeo-orto',getParentRoute: () => rootRouteImport
          })
const AprovafeoOrtoBkpRoute = AprovafeoOrtoBkpRouteImport.update({
            id: '/aprovafeo-orto-bkp',path: '/aprovafeo-orto-bkp',getParentRoute: () => rootRouteImport
          })
const AprovafeoOrtoPadraoBkpRoute = AprovafeoOrtoPadraoBkpRouteImport.update({
            id: '/aprovafeo-orto-padrao-bkp',path: '/aprovafeo-orto-padrao-bkp',getParentRoute: () => rootRouteImport
          })
const AulasExperimentaisDorRoute = AulasExperimentaisDorRouteImport.update({
            id: '/aulas-experimentais-dor',path: '/aulas-experimentais-dor',getParentRoute: () => rootRouteImport
          })
const AulasExperimentaisEsporteRoute = AulasExperimentaisEsporteRouteImport.update({
            id: '/aulas-experimentais-esporte',path: '/aulas-experimentais-esporte',getParentRoute: () => rootRouteImport
          })
const AulasExperimentaisGerontologiaRoute = AulasExperimentaisGerontologiaRouteImport.update({
            id: '/aulas-experimentais-gerontologia',path: '/aulas-experimentais-gerontologia',getParentRoute: () => rootRouteImport
          })
const AulasExperimentaisOrtoRoute = AulasExperimentaisOrtoRouteImport.update({
            id: '/aulas-experimentais-orto',path: '/aulas-experimentais-orto',getParentRoute: () => rootRouteImport
          })
const AulasExperimentaisPosTodasRoute = AulasExperimentaisPosTodasRouteImport.update({
            id: '/aulas-experimentais-pos-todas',path: '/aulas-experimentais-pos-todas',getParentRoute: () => rootRouteImport
          })
const AulasExperimentaisTraumaRoute = AulasExperimentaisTraumaRouteImport.update({
            id: '/aulas-experimentais-trauma',path: '/aulas-experimentais-trauma',getParentRoute: () => rootRouteImport
          })
const BlackFaqRoute = BlackFaqRouteImport.update({
            id: '/black-faq',path: '/black-faq',getParentRoute: () => rootRouteImport
          })
const BlackListaRoute = BlackListaRouteImport.update({
            id: '/black-lista',path: '/black-lista',getParentRoute: () => rootRouteImport
          })
const BlackListaEntregasRoute = BlackListaEntregasRouteImport.update({
            id: '/black-lista-entregas',path: '/black-lista-entregas',getParentRoute: () => rootRouteImport
          })
const BlackOfertaRoute = BlackOfertaRouteImport.update({
            id: '/black-oferta',path: '/black-oferta',getParentRoute: () => rootRouteImport
          })
const BlackOfertaAlunosRoute = BlackOfertaAlunosRouteImport.update({
            id: '/black-oferta-alunos',path: '/black-oferta-alunos',getParentRoute: () => rootRouteImport
          })
const BlackOfertaCbfeoRoute = BlackOfertaCbfeoRouteImport.update({
            id: '/black-oferta-cbfeo',path: '/black-oferta-cbfeo',getParentRoute: () => rootRouteImport
          })
const BlackOfertaEntregasRoute = BlackOfertaEntregasRouteImport.update({
            id: '/black-oferta-entregas',path: '/black-oferta-entregas',getParentRoute: () => rootRouteImport
          })
const BlackQuizzRoute = BlackQuizzRouteImport.update({
            id: '/black-quizz',path: '/black-quizz',getParentRoute: () => rootRouteImport
          })
const BlackfeoRoute = BlackfeoRouteImport.update({
            id: '/blackfeo',path: '/blackfeo',getParentRoute: () => rootRouteImport
          })
const BlackfeoEntregasRoute = BlackfeoEntregasRouteImport.update({
            id: '/blackfeo-entregas',path: '/blackfeo-entregas',getParentRoute: () => rootRouteImport
          })
const BolsasFeoProvaRoute = BolsasFeoProvaRouteImport.update({
            id: '/bolsas-feo-prova',path: '/bolsas-feo-prova',getParentRoute: () => rootRouteImport
          })
const BolsasFeoResultadosRoute = BolsasFeoResultadosRouteImport.update({
            id: '/bolsas-feo-resultados',path: '/bolsas-feo-resultados',getParentRoute: () => rootRouteImport
          })
const CbfeoRoute = CbfeoRouteImport.update({
            id: '/cbfeo',path: '/cbfeo',getParentRoute: () => rootRouteImport
          })
const CbfeoAoVivoRoute = CbfeoAoVivoRouteImport.update({
            id: '/cbfeo-ao-vivo',path: '/cbfeo-ao-vivo',getParentRoute: () => rootRouteImport
          })
const CertificacaoRoute = CertificacaoRouteImport.update({
            id: '/certificacao',path: '/certificacao',getParentRoute: () => rootRouteImport
          })
const CertificacaoBkpRoute = CertificacaoBkpRouteImport.update({
            id: '/certificacao-bkp',path: '/certificacao-bkp',getParentRoute: () => rootRouteImport
          })
const CertificacaoCervicalRoute = CertificacaoCervicalRouteImport.update({
            id: '/certificacao-cervical',path: '/certificacao-cervical',getParentRoute: () => rootRouteImport
          })
const CertificacaoEletroRoute = CertificacaoEletroRouteImport.update({
            id: '/certificacao-eletro',path: '/certificacao-eletro',getParentRoute: () => rootRouteImport
          })
const CertificacaoJoelhoRoute = CertificacaoJoelhoRouteImport.update({
            id: '/certificacao-joelho',path: '/certificacao-joelho',getParentRoute: () => rootRouteImport
          })
const CertificacaoLombarRoute = CertificacaoLombarRouteImport.update({
            id: '/certificacao-lombar',path: '/certificacao-lombar',getParentRoute: () => rootRouteImport
          })
const CertificacaoOmbroRoute = CertificacaoOmbroRouteImport.update({
            id: '/certificacao-ombro',path: '/certificacao-ombro',getParentRoute: () => rootRouteImport
          })
const CertificacaoQuadrilRoute = CertificacaoQuadrilRouteImport.update({
            id: '/certificacao-quadril',path: '/certificacao-quadril',getParentRoute: () => rootRouteImport
          })
const CertificacaoQuadrilBkpRoute = CertificacaoQuadrilBkpRouteImport.update({
            id: '/certificacao-quadril-bkp',path: '/certificacao-quadril-bkp',getParentRoute: () => rootRouteImport
          })
const CertificacaoQuadrilGrupoRoute = CertificacaoQuadrilGrupoRouteImport.update({
            id: '/certificacao-quadril-grupo',path: '/certificacao-quadril-grupo',getParentRoute: () => rootRouteImport
          })
const CertificacaoQuadrilOfertaRoute = CertificacaoQuadrilOfertaRouteImport.update({
            id: '/certificacao-quadril-oferta',path: '/certificacao-quadril-oferta',getParentRoute: () => rootRouteImport
          })
const CertificacaoQuadrilV2Route = CertificacaoQuadrilV2RouteImport.update({
            id: '/certificacao-quadril-v2',path: '/certificacao-quadril-v2',getParentRoute: () => rootRouteImport
          })
const CertificacaoQuadril2Route = CertificacaoQuadril2RouteImport.update({
            id: '/certificacao-quadril2',path: '/certificacao-quadril2',getParentRoute: () => rootRouteImport
          })
const CertificacaoStarRoute = CertificacaoStarRouteImport.update({
            id: '/certificacao-star',path: '/certificacao-star',getParentRoute: () => rootRouteImport
          })
const CertificacaoTornozeloRoute = CertificacaoTornozeloRouteImport.update({
            id: '/certificacao-tornozelo',path: '/certificacao-tornozelo',getParentRoute: () => rootRouteImport
          })
const ComboImersoesRoute = ComboImersoesRouteImport.update({
            id: '/combo-imersoes',path: '/combo-imersoes',getParentRoute: () => rootRouteImport
          })
const DepoimentosRoute = DepoimentosRouteImport.update({
            id: '/depoimentos',path: '/depoimentos',getParentRoute: () => rootRouteImport
          })
const Dor1Route = Dor1RouteImport.update({
            id: '/dor1',path: '/dor1',getParentRoute: () => rootRouteImport
          })
const Dor2Route = Dor2RouteImport.update({
            id: '/dor2',path: '/dor2',getParentRoute: () => rootRouteImport
          })
const EFisioRoute = EFisioRouteImport.update({
            id: '/e-fisio',path: '/e-fisio',getParentRoute: () => rootRouteImport
          })
const EmentaDorRoute = EmentaDorRouteImport.update({
            id: '/ementa-dor',path: '/ementa-dor',getParentRoute: () => rootRouteImport
          })
const EmentaEsporteRoute = EmentaEsporteRouteImport.update({
            id: '/ementa-esporte',path: '/ementa-esporte',getParentRoute: () => rootRouteImport
          })
const EmentaGerontoRoute = EmentaGerontoRouteImport.update({
            id: '/ementa-geronto',path: '/ementa-geronto',getParentRoute: () => rootRouteImport
          })
const EmentaOrtoRoute = EmentaOrtoRouteImport.update({
            id: '/ementa-orto',path: '/ementa-orto',getParentRoute: () => rootRouteImport
          })
const EmentaPrescricaoRoute = EmentaPrescricaoRouteImport.update({
            id: '/ementa-prescricao',path: '/ementa-prescricao',getParentRoute: () => rootRouteImport
          })
const EmentaTraumaRoute = EmentaTraumaRouteImport.update({
            id: '/ementa-trauma',path: '/ementa-trauma',getParentRoute: () => rootRouteImport
          })
const EmentasRoute = EmentasRouteImport.update({
            id: '/ementas',path: '/ementas',getParentRoute: () => rootRouteImport
          })
const Esporte1Route = Esporte1RouteImport.update({
            id: '/esporte1',path: '/esporte1',getParentRoute: () => rootRouteImport
          })
const Esporte2Route = Esporte2RouteImport.update({
            id: '/esporte2',path: '/esporte2',getParentRoute: () => rootRouteImport
          })
const FeoclinicasRoute = FeoclinicasRouteImport.update({
            id: '/feoclinicas',path: '/feoclinicas',getParentRoute: () => rootRouteImport
          })
const Feoclinicas2Route = Feoclinicas2RouteImport.update({
            id: '/feoclinicas-2',path: '/feoclinicas-2',getParentRoute: () => rootRouteImport
          })
const FisiocompletoRoute = FisiocompletoRouteImport.update({
            id: '/fisiocompleto',path: '/fisiocompleto',getParentRoute: () => rootRouteImport
          })
const FisiocompletoVendaRoute = FisiocompletoVendaRouteImport.update({
            id: '/fisiocompleto-venda',path: '/fisiocompleto-venda',getParentRoute: () => rootRouteImport
          })
const FisiocompletoWppRoute = FisiocompletoWppRouteImport.update({
            id: '/fisiocompleto-wpp',path: '/fisiocompleto-wpp',getParentRoute: () => rootRouteImport
          })
const FlashfeoRoute = FlashfeoRouteImport.update({
            id: '/flashfeo',path: '/flashfeo',getParentRoute: () => rootRouteImport
          })
const FunilLcaRoute = FunilLcaRouteImport.update({
            id: '/funil-lca',path: '/funil-lca',getParentRoute: () => rootRouteImport
          })
const FunilLcaComboImersoesRoute = FunilLcaComboImersoesRouteImport.update({
            id: '/funil-lca-combo-imersoes',path: '/funil-lca-combo-imersoes',getParentRoute: () => rootRouteImport
          })
const FunilSdfpRoute = FunilSdfpRouteImport.update({
            id: '/funil-sdfp',path: '/funil-sdfp',getParentRoute: () => rootRouteImport
          })
const FunilSdfpComboImersoesRoute = FunilSdfpComboImersoesRouteImport.update({
            id: '/funil-sdfp-combo-imersoes',path: '/funil-sdfp-combo-imersoes',getParentRoute: () => rootRouteImport
          })
const FunilTmanualRoute = FunilTmanualRouteImport.update({
            id: '/funil-tmanual',path: '/funil-tmanual',getParentRoute: () => rootRouteImport
          })
const FunilTmanualComboImersoesRoute = FunilTmanualComboImersoesRouteImport.update({
            id: '/funil-tmanual-combo-imersoes',path: '/funil-tmanual-combo-imersoes',getParentRoute: () => rootRouteImport
          })
const FunilUsRoute = FunilUsRouteImport.update({
            id: '/funil-us',path: '/funil-us',getParentRoute: () => rootRouteImport
          })
const FunilUsComboImersoesRoute = FunilUsComboImersoesRouteImport.update({
            id: '/funil-us-combo-imersoes',path: '/funil-us-combo-imersoes',getParentRoute: () => rootRouteImport
          })
const Geronto1Route = Geronto1RouteImport.update({
            id: '/geronto1',path: '/geronto1',getParentRoute: () => rootRouteImport
          })
const Geronto2Route = Geronto2RouteImport.update({
            id: '/geronto2',path: '/geronto2',getParentRoute: () => rootRouteImport
          })
const ImersaoPbeRoute = ImersaoPbeRouteImport.update({
            id: '/imersao-pbe',path: '/imersao-pbe',getParentRoute: () => rootRouteImport
          })
const ImersaoPbeStarRoute = ImersaoPbeStarRouteImport.update({
            id: '/imersao-pbe-star',path: '/imersao-pbe-star',getParentRoute: () => rootRouteImport
          })
const InteligenciaBlack25Route = InteligenciaBlack25RouteImport.update({
            id: '/inteligencia-black25',path: '/inteligencia-black25',getParentRoute: () => rootRouteImport
          })
const InteligenciaGolpeRoute = InteligenciaGolpeRouteImport.update({
            id: '/inteligencia-golpe',path: '/inteligencia-golpe',getParentRoute: () => rootRouteImport
          })
const Orto1Route = Orto1RouteImport.update({
            id: '/orto1',path: '/orto1',getParentRoute: () => rootRouteImport
          })
const Orto2Route = Orto2RouteImport.update({
            id: '/orto2',path: '/orto2',getParentRoute: () => rootRouteImport
          })
const PassaporteRoute = PassaporteRouteImport.update({
            id: '/passaporte',path: '/passaporte',getParentRoute: () => rootRouteImport
          })
const PlantaofeoRoute = PlantaofeoRouteImport.update({
            id: '/plantaofeo',path: '/plantaofeo',getParentRoute: () => rootRouteImport
          })
const PoliticaDePrivacidadeRoute = PoliticaDePrivacidadeRouteImport.update({
            id: '/politica-de-privacidade',path: '/politica-de-privacidade',getParentRoute: () => rootRouteImport
          })
const PosRoute = PosRouteImport.update({
            id: '/pos',path: '/pos',getParentRoute: () => rootRouteImport
          })
const PosBkpRoute = PosBkpRouteImport.update({
            id: '/pos-bkp',path: '/pos-bkp',getParentRoute: () => rootRouteImport
          })
const PosGgRoute = PosGgRouteImport.update({
            id: '/pos-gg',path: '/pos-gg',getParentRoute: () => rootRouteImport
          })
const Prescricao1Route = Prescricao1RouteImport.update({
            id: '/prescricao1',path: '/prescricao1',getParentRoute: () => rootRouteImport
          })
const Prescricao2Route = Prescricao2RouteImport.update({
            id: '/prescricao2',path: '/prescricao2',getParentRoute: () => rootRouteImport
          })
const ProfessoresRoute = ProfessoresRouteImport.update({
            id: '/professores',path: '/professores',getParentRoute: () => rootRouteImport
          })
const QuemSomosRoute = QuemSomosRouteImport.update({
            id: '/quem-somos',path: '/quem-somos',getParentRoute: () => rootRouteImport
          })
const QuizzDorPosTodasRoute = QuizzDorPosTodasRouteImport.update({
            id: '/quizz-dor-pos-todas',path: '/quizz-dor-pos-todas',getParentRoute: () => rootRouteImport
          })
const QuizzPosTodasRoute = QuizzPosTodasRouteImport.update({
            id: '/quizz-pos-todas',path: '/quizz-pos-todas',getParentRoute: () => rootRouteImport
          })
const RevistaRoute = RevistaRouteImport.update({
            id: '/revista',path: '/revista',getParentRoute: () => rootRouteImport
          })
const RevistaStarRoute = RevistaStarRouteImport.update({
            id: '/revista-star',path: '/revista-star',getParentRoute: () => rootRouteImport
          })
const RoteiroAvaliacao1Route = RoteiroAvaliacao1RouteImport.update({
            id: '/roteiro-avaliacao-1',path: '/roteiro-avaliacao-1',getParentRoute: () => rootRouteImport
          })
const RoteiroAvaliacao2Route = RoteiroAvaliacao2RouteImport.update({
            id: '/roteiro-avaliacao-2',path: '/roteiro-avaliacao-2',getParentRoute: () => rootRouteImport
          })
const SemanadafisioRoute = SemanadafisioRouteImport.update({
            id: '/semanadafisio',path: '/semanadafisio',getParentRoute: () => rootRouteImport
          })
const SemanadafisioAulasRoute = SemanadafisioAulasRouteImport.update({
            id: '/semanadafisio-aulas',path: '/semanadafisio-aulas',getParentRoute: () => rootRouteImport
          })
const SemanadafisioggRoute = SemanadafisioggRouteImport.update({
            id: '/semanadafisiogg',path: '/semanadafisiogg',getParentRoute: () => rootRouteImport
          })
const StarRoute = StarRouteImport.update({
            id: '/star',path: '/star',getParentRoute: () => rootRouteImport
          })
const Star2Route = Star2RouteImport.update({
            id: '/star2',path: '/star2',getParentRoute: () => rootRouteImport
          })
const Trauma1Route = Trauma1RouteImport.update({
            id: '/trauma1',path: '/trauma1',getParentRoute: () => rootRouteImport
          })
const Trauma2Route = Trauma2RouteImport.update({
            id: '/trauma2',path: '/trauma2',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminAcessosRoute = AdminAcessosRouteImport.update({
            id: '/admin/acessos',path: '/admin/acessos',getParentRoute: () => rootRouteImport
          })
const AdminAcoesMarketingRoute = AdminAcoesMarketingRouteImport.update({
            id: '/admin/acoes-marketing',path: '/admin/acoes-marketing',getParentRoute: () => rootRouteImport
          })
const AdminAdminRoute = AdminAdminRouteImport.update({
            id: '/admin/admin',path: '/admin/admin',getParentRoute: () => rootRouteImport
          })
const AdminBannerRoute = AdminBannerRouteImport.update({
            id: '/admin/banner',path: '/admin/banner',getParentRoute: () => rootRouteImport
          })
const AdminBibliotecaAnunciosRoute = AdminBibliotecaAnunciosRouteImport.update({
            id: '/admin/biblioteca-anuncios',path: '/admin/biblioteca-anuncios',getParentRoute: () => rootRouteImport
          })
const AdminBlackDashboardRoute = AdminBlackDashboardRouteImport.update({
            id: '/admin/black-dashboard',path: '/admin/black-dashboard',getParentRoute: () => rootRouteImport
          })
const AdminBlackLeadsRoute = AdminBlackLeadsRouteImport.update({
            id: '/admin/black-leads',path: '/admin/black-leads',getParentRoute: () => rootRouteImport
          })
const AdminBlackNovemberRoute = AdminBlackNovemberRouteImport.update({
            id: '/admin/black-november',path: '/admin/black-november',getParentRoute: () => rootRouteImport
          })
const AdminBlackNovemberDashboardRoute = AdminBlackNovemberDashboardRouteImport.update({
            id: '/admin/black-november-dashboard',path: '/admin/black-november-dashboard',getParentRoute: () => rootRouteImport
          })
const AdminBlackNovemberPaginasRoute = AdminBlackNovemberPaginasRouteImport.update({
            id: '/admin/black-november-paginas',path: '/admin/black-november-paginas',getParentRoute: () => rootRouteImport
          })
const AdminBlack25CrmDiretaRoute = AdminBlack25CrmDiretaRouteImport.update({
            id: '/admin/black25-crm-direta',path: '/admin/black25-crm-direta',getParentRoute: () => rootRouteImport
          })
const AdminBolsasFeoRoute = AdminBolsasFeoRouteImport.update({
            id: '/admin/bolsas-feo',path: '/admin/bolsas-feo',getParentRoute: () => rootRouteImport
          })
const AdminCampanhasRoute = AdminCampanhasRouteImport.update({
            id: '/admin/campanhas',path: '/admin/campanhas',getParentRoute: () => rootRouteImport
          })
const AdminCampanhasModeloRoute = AdminCampanhasModeloRouteImport.update({
            id: '/admin/campanhas-modelo',path: '/admin/campanhas-modelo',getParentRoute: () => rootRouteImport
          })
const AdminConfiguracoesRoute = AdminConfiguracoesRouteImport.update({
            id: '/admin/configuracoes',path: '/admin/configuracoes',getParentRoute: () => rootRouteImport
          })
const AdminContextoRoute = AdminContextoRouteImport.update({
            id: '/admin/contexto',path: '/admin/contexto',getParentRoute: () => rootRouteImport
          })
const AdminCopysRoute = AdminCopysRouteImport.update({
            id: '/admin/copys',path: '/admin/copys',getParentRoute: () => rootRouteImport
          })
const AdminDashboardRoute = AdminDashboardRouteImport.update({
            id: '/admin/dashboard',path: '/admin/dashboard',getParentRoute: () => rootRouteImport
          })
const AdminDashboard2Route = AdminDashboard2RouteImport.update({
            id: '/admin/dashboard-2',path: '/admin/dashboard-2',getParentRoute: () => rootRouteImport
          })
const AdminDepoimentosRoute = AdminDepoimentosRouteImport.update({
            id: '/admin/depoimentos',path: '/admin/depoimentos',getParentRoute: () => rootRouteImport
          })
const AdminDiagnosticoComercialRoute = AdminDiagnosticoComercialRouteImport.update({
            id: '/admin/diagnostico-comercial',path: '/admin/diagnostico-comercial',getParentRoute: () => rootRouteImport
          })
const AdminEFisioRoute = AdminEFisioRouteImport.update({
            id: '/admin/e-fisio',path: '/admin/e-fisio',getParentRoute: () => rootRouteImport
          })
const AdminFeoGuardRoute = AdminFeoGuardRouteImport.update({
            id: '/admin/feo-guard',path: '/admin/feo-guard',getParentRoute: () => rootRouteImport
          })
const AdminFeoclinicasRoute = AdminFeoclinicasRouteImport.update({
            id: '/admin/feoclinicas',path: '/admin/feoclinicas',getParentRoute: () => rootRouteImport
          })
const AdminHistoricoRoute = AdminHistoricoRouteImport.update({
            id: '/admin/historico',path: '/admin/historico',getParentRoute: () => rootRouteImport
          })
const AdminHistoricoOperacaoRoute = AdminHistoricoOperacaoRouteImport.update({
            id: '/admin/historico-operacao',path: '/admin/historico-operacao',getParentRoute: () => rootRouteImport
          })
const AdminInteligenciaLeadsRoute = AdminInteligenciaLeadsRouteImport.update({
            id: '/admin/inteligencia-leads',path: '/admin/inteligencia-leads',getParentRoute: () => rootRouteImport
          })
const AdminInteligenciaMarketingRoute = AdminInteligenciaMarketingRouteImport.update({
            id: '/admin/inteligencia-marketing',path: '/admin/inteligencia-marketing',getParentRoute: () => rootRouteImport
          })
const AdminLeadsRoute = AdminLeadsRouteImport.update({
            id: '/admin/leads',path: '/admin/leads',getParentRoute: () => rootRouteImport
          })
const AdminMapaRoute = AdminMapaRouteImport.update({
            id: '/admin/mapa',path: '/admin/mapa',getParentRoute: () => rootRouteImport
          })
const AdminPainelRoute = AdminPainelRouteImport.update({
            id: '/admin/painel',path: '/admin/painel',getParentRoute: () => rootRouteImport
          })
const AdminPlacarRoute = AdminPlacarRouteImport.update({
            id: '/admin/placar',path: '/admin/placar',getParentRoute: () => rootRouteImport
          })
const AdminPlanoB2bRoute = AdminPlanoB2bRouteImport.update({
            id: '/admin/plano-b2b',path: '/admin/plano-b2b',getParentRoute: () => rootRouteImport
          })
const AdminPlanoBlack2x1Route = AdminPlanoBlack2x1RouteImport.update({
            id: '/admin/plano-black-2x1',path: '/admin/plano-black-2x1',getParentRoute: () => rootRouteImport
          })
const AdminPlanoBlackNovemberRoute = AdminPlanoBlackNovemberRouteImport.update({
            id: '/admin/plano-black-november',path: '/admin/plano-black-november',getParentRoute: () => rootRouteImport
          })
const AdminPlanoBolsasFeoRoute = AdminPlanoBolsasFeoRouteImport.update({
            id: '/admin/plano-bolsas-feo',path: '/admin/plano-bolsas-feo',getParentRoute: () => rootRouteImport
          })
const AdminPlanoEFisioRoute = AdminPlanoEFisioRouteImport.update({
            id: '/admin/plano-e-fisio',path: '/admin/plano-e-fisio',getParentRoute: () => rootRouteImport
          })
const AdminPlanoInteligenciaLeadsRoute = AdminPlanoInteligenciaLeadsRouteImport.update({
            id: '/admin/plano-inteligencia-leads',path: '/admin/plano-inteligencia-leads',getParentRoute: () => rootRouteImport
          })
const AdminPlanoLeadsRdCrmRoute = AdminPlanoLeadsRdCrmRouteImport.update({
            id: '/admin/plano-leads-rd-crm',path: '/admin/plano-leads-rd-crm',getParentRoute: () => rootRouteImport
          })
const AdminPlanoMigracaoRoute = AdminPlanoMigracaoRouteImport.update({
            id: '/admin/plano-migracao',path: '/admin/plano-migracao',getParentRoute: () => rootRouteImport
          })
const AdminPlanoPaginasRoute = AdminPlanoPaginasRouteImport.update({
            id: '/admin/plano-paginas',path: '/admin/plano-paginas',getParentRoute: () => rootRouteImport
          })
const AdminPlanoRevisaoPreBlackRoute = AdminPlanoRevisaoPreBlackRouteImport.update({
            id: '/admin/plano-revisao-pre-black',path: '/admin/plano-revisao-pre-black',getParentRoute: () => rootRouteImport
          })
const AdminPlanoRoteadorGruposRoute = AdminPlanoRoteadorGruposRouteImport.update({
            id: '/admin/plano-roteador-grupos',path: '/admin/plano-roteador-grupos',getParentRoute: () => rootRouteImport
          })
const AdminPlanoTrackingGtmRoute = AdminPlanoTrackingGtmRouteImport.update({
            id: '/admin/plano-tracking-gtm',path: '/admin/plano-tracking-gtm',getParentRoute: () => rootRouteImport
          })
const AdminPlanosRoute = AdminPlanosRouteImport.update({
            id: '/admin/planos',path: '/admin/planos',getParentRoute: () => rootRouteImport
          })
const AdminPublicosRoute = AdminPublicosRouteImport.update({
            id: '/admin/publicos',path: '/admin/publicos',getParentRoute: () => rootRouteImport
          })
const AdminQuizzRoute = AdminQuizzRouteImport.update({
            id: '/admin/quizz',path: '/admin/quizz',getParentRoute: () => rootRouteImport
          })
const AdminReportsRoute = AdminReportsRouteImport.update({
            id: '/admin/reports',path: '/admin/reports',getParentRoute: () => rootRouteImport
          })
const EFisioIndexRoute = EFisioIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EFisioRoute
          })
const EFisioSlugRoute = EFisioSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => EFisioRoute
          })
const AdminEFisioConfiguracoesRoute = AdminEFisioConfiguracoesRouteImport.update({
            id: '/admin/e-fisio_/configuracoes',path: '/admin/e-fisio/configuracoes',getParentRoute: () => rootRouteImport
          })
const EFisioCategoriaSlugRoute = EFisioCategoriaSlugRouteImport.update({
            id: '/categoria/$slug',path: '/categoria/$slug',getParentRoute: () => EFisioRoute
          })
const EmbedBannerSlideKeyRoute = EmbedBannerSlideKeyRouteImport.update({
            id: '/embed/banner-slide/$key',path: '/embed/banner-slide/$key',getParentRoute: () => rootRouteImport
          })
const EmbedEmentaSlugRoute = EmbedEmentaSlugRouteImport.update({
            id: '/embed/ementa/$slug',path: '/embed/ementa/$slug',getParentRoute: () => rootRouteImport
          })
const EmbedPreCheckoutGgSlugRoute = EmbedPreCheckoutGgSlugRouteImport.update({
            id: '/embed/pre-checkout-gg/$slug',path: '/embed/pre-checkout-gg/$slug',getParentRoute: () => rootRouteImport
          })
const EmbedPreCheckoutSlugRoute = EmbedPreCheckoutSlugRouteImport.update({
            id: '/embed/pre-checkout/$slug',path: '/embed/pre-checkout/$slug',getParentRoute: () => rootRouteImport
          })





const EFisioRouteChildren = {
  EFisioSlugRoute: EFisioSlugRoute,EFisioIndexRoute: EFisioIndexRoute,EFisioCategoriaSlugRoute: EFisioCategoriaSlugRoute
}

const EFisioRouteWithChildren = EFisioRoute._addFileChildren(EFisioRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AgenteRaciocinioRoute: AgenteRaciocinioRoute,AprovafeoOrtoRoute: AprovafeoOrtoRoute,AprovafeoOrtoBkpRoute: AprovafeoOrtoBkpRoute,AprovafeoOrtoPadraoBkpRoute: AprovafeoOrtoPadraoBkpRoute,AulasExperimentaisDorRoute: AulasExperimentaisDorRoute,AulasExperimentaisEsporteRoute: AulasExperimentaisEsporteRoute,AulasExperimentaisGerontologiaRoute: AulasExperimentaisGerontologiaRoute,AulasExperimentaisOrtoRoute: AulasExperimentaisOrtoRoute,AulasExperimentaisPosTodasRoute: AulasExperimentaisPosTodasRoute,AulasExperimentaisTraumaRoute: AulasExperimentaisTraumaRoute,BlackFaqRoute: BlackFaqRoute,BlackListaRoute: BlackListaRoute,BlackListaEntregasRoute: BlackListaEntregasRoute,BlackOfertaRoute: BlackOfertaRoute,BlackOfertaAlunosRoute: BlackOfertaAlunosRoute,BlackOfertaCbfeoRoute: BlackOfertaCbfeoRoute,BlackOfertaEntregasRoute: BlackOfertaEntregasRoute,BlackQuizzRoute: BlackQuizzRoute,BlackfeoRoute: BlackfeoRoute,BlackfeoEntregasRoute: BlackfeoEntregasRoute,BolsasFeoProvaRoute: BolsasFeoProvaRoute,BolsasFeoResultadosRoute: BolsasFeoResultadosRoute,CbfeoRoute: CbfeoRoute,CbfeoAoVivoRoute: CbfeoAoVivoRoute,CertificacaoRoute: CertificacaoRoute,CertificacaoBkpRoute: CertificacaoBkpRoute,CertificacaoCervicalRoute: CertificacaoCervicalRoute,CertificacaoEletroRoute: CertificacaoEletroRoute,CertificacaoJoelhoRoute: CertificacaoJoelhoRoute,CertificacaoLombarRoute: CertificacaoLombarRoute,CertificacaoOmbroRoute: CertificacaoOmbroRoute,CertificacaoQuadrilRoute: CertificacaoQuadrilRoute,CertificacaoQuadrilBkpRoute: CertificacaoQuadrilBkpRoute,CertificacaoQuadrilGrupoRoute: CertificacaoQuadrilGrupoRoute,CertificacaoQuadrilOfertaRoute: CertificacaoQuadrilOfertaRoute,CertificacaoQuadrilV2Route: CertificacaoQuadrilV2Route,CertificacaoQuadril2Route: CertificacaoQuadril2Route,CertificacaoStarRoute: CertificacaoStarRoute,CertificacaoTornozeloRoute: CertificacaoTornozeloRoute,ComboImersoesRoute: ComboImersoesRoute,DepoimentosRoute: DepoimentosRoute,Dor1Route: Dor1Route,Dor2Route: Dor2Route,EFisioRoute: EFisioRouteWithChildren,EmentaDorRoute: EmentaDorRoute,EmentaEsporteRoute: EmentaEsporteRoute,EmentaGerontoRoute: EmentaGerontoRoute,EmentaOrtoRoute: EmentaOrtoRoute,EmentaPrescricaoRoute: EmentaPrescricaoRoute,EmentaTraumaRoute: EmentaTraumaRoute,EmentasRoute: EmentasRoute,Esporte1Route: Esporte1Route,Esporte2Route: Esporte2Route,FeoclinicasRoute: FeoclinicasRoute,Feoclinicas2Route: Feoclinicas2Route,FisiocompletoRoute: FisiocompletoRoute,FisiocompletoVendaRoute: FisiocompletoVendaRoute,FisiocompletoWppRoute: FisiocompletoWppRoute,FlashfeoRoute: FlashfeoRoute,FunilLcaRoute: FunilLcaRoute,FunilLcaComboImersoesRoute: FunilLcaComboImersoesRoute,FunilSdfpRoute: FunilSdfpRoute,FunilSdfpComboImersoesRoute: FunilSdfpComboImersoesRoute,FunilTmanualRoute: FunilTmanualRoute,FunilTmanualComboImersoesRoute: FunilTmanualComboImersoesRoute,FunilUsRoute: FunilUsRoute,FunilUsComboImersoesRoute: FunilUsComboImersoesRoute,Geronto1Route: Geronto1Route,Geronto2Route: Geronto2Route,ImersaoPbeRoute: ImersaoPbeRoute,ImersaoPbeStarRoute: ImersaoPbeStarRoute,InteligenciaBlack25Route: InteligenciaBlack25Route,InteligenciaGolpeRoute: InteligenciaGolpeRoute,Orto1Route: Orto1Route,Orto2Route: Orto2Route,PassaporteRoute: PassaporteRoute,PlantaofeoRoute: PlantaofeoRoute,PoliticaDePrivacidadeRoute: PoliticaDePrivacidadeRoute,PosRoute: PosRoute,PosBkpRoute: PosBkpRoute,PosGgRoute: PosGgRoute,Prescricao1Route: Prescricao1Route,Prescricao2Route: Prescricao2Route,ProfessoresRoute: ProfessoresRoute,QuemSomosRoute: QuemSomosRoute,QuizzDorPosTodasRoute: QuizzDorPosTodasRoute,QuizzPosTodasRoute: QuizzPosTodasRoute,RevistaRoute: RevistaRoute,RevistaStarRoute: RevistaStarRoute,RoteiroAvaliacao1Route: RoteiroAvaliacao1Route,RoteiroAvaliacao2Route: RoteiroAvaliacao2Route,SemanadafisioRoute: SemanadafisioRoute,SemanadafisioAulasRoute: SemanadafisioAulasRoute,SemanadafisioggRoute: SemanadafisioggRoute,StarRoute: StarRoute,Star2Route: Star2Route,Trauma1Route: Trauma1Route,Trauma2Route: Trauma2Route,AdminAcessosRoute: AdminAcessosRoute,AdminAcoesMarketingRoute: AdminAcoesMarketingRoute,AdminAdminRoute: AdminAdminRoute,AdminBannerRoute: AdminBannerRoute,AdminBibliotecaAnunciosRoute: AdminBibliotecaAnunciosRoute,AdminBlackDashboardRoute: AdminBlackDashboardRoute,AdminBlackLeadsRoute: AdminBlackLeadsRoute,AdminBlackNovemberRoute: AdminBlackNovemberRoute,AdminBlackNovemberDashboardRoute: AdminBlackNovemberDashboardRoute,AdminBlackNovemberPaginasRoute: AdminBlackNovemberPaginasRoute,AdminBlack25CrmDiretaRoute: AdminBlack25CrmDiretaRoute,AdminBolsasFeoRoute: AdminBolsasFeoRoute,AdminCampanhasRoute: AdminCampanhasRoute,AdminCampanhasModeloRoute: AdminCampanhasModeloRoute,AdminConfiguracoesRoute: AdminConfiguracoesRoute,AdminContextoRoute: AdminContextoRoute,AdminCopysRoute: AdminCopysRoute,AdminDashboardRoute: AdminDashboardRoute,AdminDashboard2Route: AdminDashboard2Route,AdminDepoimentosRoute: AdminDepoimentosRoute,AdminDiagnosticoComercialRoute: AdminDiagnosticoComercialRoute,AdminEFisioRoute: AdminEFisioRoute,AdminFeoGuardRoute: AdminFeoGuardRoute,AdminFeoclinicasRoute: AdminFeoclinicasRoute,AdminHistoricoRoute: AdminHistoricoRoute,AdminHistoricoOperacaoRoute: AdminHistoricoOperacaoRoute,AdminInteligenciaLeadsRoute: AdminInteligenciaLeadsRoute,AdminInteligenciaMarketingRoute: AdminInteligenciaMarketingRoute,AdminLeadsRoute: AdminLeadsRoute,AdminMapaRoute: AdminMapaRoute,AdminPainelRoute: AdminPainelRoute,AdminPlacarRoute: AdminPlacarRoute,AdminPlanoB2bRoute: AdminPlanoB2bRoute,AdminPlanoBlack2x1Route: AdminPlanoBlack2x1Route,AdminPlanoBlackNovemberRoute: AdminPlanoBlackNovemberRoute,AdminPlanoBolsasFeoRoute: AdminPlanoBolsasFeoRoute,AdminPlanoEFisioRoute: AdminPlanoEFisioRoute,AdminPlanoInteligenciaLeadsRoute: AdminPlanoInteligenciaLeadsRoute,AdminPlanoLeadsRdCrmRoute: AdminPlanoLeadsRdCrmRoute,AdminPlanoMigracaoRoute: AdminPlanoMigracaoRoute,AdminPlanoPaginasRoute: AdminPlanoPaginasRoute,AdminPlanoRevisaoPreBlackRoute: AdminPlanoRevisaoPreBlackRoute,AdminPlanoRoteadorGruposRoute: AdminPlanoRoteadorGruposRoute,AdminPlanoTrackingGtmRoute: AdminPlanoTrackingGtmRoute,AdminPlanosRoute: AdminPlanosRoute,AdminPublicosRoute: AdminPublicosRoute,AdminQuizzRoute: AdminQuizzRoute,AdminReportsRoute: AdminReportsRoute,AdminIndexRoute: AdminIndexRoute,AdminEFisioConfiguracoesRoute: AdminEFisioConfiguracoesRoute,EmbedBannerSlideKeyRoute: EmbedBannerSlideKeyRoute,EmbedEmentaSlugRoute: EmbedEmentaSlugRoute,EmbedPreCheckoutGgSlugRoute: EmbedPreCheckoutGgSlugRoute,EmbedPreCheckoutSlugRoute: EmbedPreCheckoutSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)